import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./AboutUsTestimonials.css";

const AboutUsTestimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <div className="testimonial2 about-page-tes sp bg1">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto text-center">
              <div className="heading1">
                <span className="span"><img src="/assets/img/icons/span1.png" alt="" /> Testimonials</span>
                <h2>See What Our Customer Say's</h2>
              </div>
            </div>
          </div>

          <div className="space60"></div>
          <div className="row">
            <Slider {...settings} className="tes2-slider custom-testimonial-slider">
              <div className="single-slider testimonial-card">
                <div className="icon">
                  <img src="/assets/img/icons/about-page-qute.png" alt="" />
                </div>
                <p className="pera">"As a fintech company which handles payments across borders, it's really important to have access to correct and up-to-date currency rates. IBRLIVE API has made our work easier, cut down on mistakes, and earned our clients' trust. "The integration went off without a hitch, and the support is great."</p>

                <div className="bottom-area">
                  <div className="author">
                  Rohit Mehra, founder
                  </div>
                  <div className="reating">
                    <ul>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star-half"></i></li>
                    </ul>
                    <p>(4.5)</p>
                  </div>
                </div>
              </div>

              <div className="single-slider testimonial-card">
                <div className="icon">
                  <img src="/assets/img/icons/about-page-qute.png" alt="" />
                </div>
                <p className="pera">"Our online store sells to people all around the world, therefore we needed a means to show prices in different currencies that we could trust. It was easy to do with the IBRLIVE's Exchange Rate API in only a few lines of code. "It works quickly and accurately, and it has helped us get more sales."</p>

                <div className="bottom-area">
                  <div className="author">
                  Ananya Iyer, Co-Founder 
                  </div>
                  <div className="reating">
                    <ul>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                    </ul>
                    <p>(4.5)</p>
                  </div>
                </div>
              </div>

              <div className="single-slider testimonial-card">
                <div className="icon">
                  <img src="/assets/img/icons/about-page-qute.png" alt="" />
                </div>
                <p className="pera">"It was always hard for us to maintain track of fiat-to-crypto rates for our crypto exchange. IBRLIVE API gives us real-time updates and clear rates, which has made users feel more confident. "Highly recommended for anyone who works in crypto or foreign exchange."</p>

                <div className="bottom-area">
                  <div className="author">
                  Kunal Sharma, CTO
                  </div>
                  <div className="reating">
                    <ul>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star-half"></i></li>
                    </ul>
                    <p>(4.5)</p>
                  </div>
                </div>
              </div>

              <div className="single-slider testimonial-card">
                <div className="icon">
                  <img src="/assets/img/icons/about-page-qute.png" alt="" />
                </div>
                <p className="pera">"We help firms manage their foreign exchange risk, and accuracy is key. IBRLIVE API has changed the game. It gives you real-time data, is always online, and includes easy-to-understand documentation. "It really makes our consulting services better."</p>

                <div className="bottom-area">
                  <div className="author">
                  Emily Chen, Managing Partner
                  </div>
                  <div className="reating">
                    <ul>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star-half"></i></li>
                    </ul>
                    <p>(4.5)</p>
                  </div>
                </div>
              </div>

              <div className="single-slider testimonial-card">
                <div className="icon">
                  <img src="/assets/img/icons/about-page-qute.png" alt="" />
                </div>
                <p className="pera">"As a developer, I've used a lot of APIs, but the one from IBRLIVE stands out since its documentation is clear and it responds quickly. I added it to a client's app in less than an hour. The real-time currency data is very reliable, therefore this is my go-to API for exchange rates."</p>

                <div className="bottom-area">
                  <div className="author">
                  Michael Johnson, a freelance developer in New York
                  </div>
                  <div className="reating">
                    <ul>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                    </ul>
                    <p>(4.5)</p>
                  </div>
                </div>
              </div>

              <div className="single-slider testimonial-card">
                <div className="icon">
                  <img src="/assets/img/icons/about-page-qute.png" alt="" />
                </div>
                <p className="pera">"TechXen has been our go-to partner for IT support for several years now, and they have consistently delivered outstanding service. Their team is highly responsive, knowledgeable, reliable. Thanks to their expertise, we've been able to overcome various IT challenges focus growing business."</p>

                <div className="bottom-area">
                  <div className="author">
                    <a href="#testimonial-author">Scott Boland</a>
                  </div>
                  <div className="reating">
                    <ul>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star"></i></li>
                      <li><i className="fa-solid fa-star-half"></i></li>
                    </ul>
                    <p>(4.5)</p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUsTestimonials;